import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { Modal, Button, Form } from 'react-bootstrap';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useForm, Controller } from "react-hook-form";
import { formatDate } from "../utils/dateFormatter";


const ViewPayment = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const garageId = decodeURIComponent(location.pathname.split('/viewpayment/')[1]);

    const userUID = useSelector(state => state.user.uid);
    const userType = useSelector(state => state.user.userType);
    const [data, setData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10;

    useEffect(() => {
        console.log('garageId', garageId);
        axios.post(`${process.env.REACT_APP_API_URL}`, { action: 'GetAllPayments', id: garageId })
            .then(response => {
                setData(response.data.data);
                console.log("response", response.data.data);
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }, [garageId]);

    const filteredData = data.filter((item) =>
        item && item.description.toLowerCase().includes(searchQuery.toLowerCase())
    );

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const displayedData = filteredData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const formatApplicationFee = (item) => {
        const rawFee = Number(item?.application_fee || 0);
        const amount = Number(item?.amount || 0);

        if (!Number.isFinite(rawFee)) {
            return '0.00';
        }

        const normalizedFee = rawFee > amount && rawFee > 0 ? rawFee / 100 : rawFee;
        return normalizedFee.toFixed(2);
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };


    const [selectedContractId, setSelectedContractId] = useState(null);

    const OpenModal = (id, modalid) => {
        setSelectedContractId(id);
        document.getElementById(modalid).classList.add('show');
        document.getElementById(modalid).style.display = 'block';
    };

    const closeModal = (modalid) => {
        document.getElementById(modalid).classList.remove('show');
        document.getElementById(modalid).style.display = 'none';
        setSelectedContractId(null);
    };
    const {
        control: control2,
        register: register2,
        handleSubmit: handleSubmit2,
        formState: { errors: errors2 },
    } = useForm();

    const handleAcceptModalSubmit = async (data) => {

        Swal.fire({
            title: 'Updating, please wait',
            html:
                '<div class="loadingio-spinner-rolling-w23e05eix9"><div class="ldio-ik6pzj2wupc"><div></div></div></div>',
            showConfirmButton: false,
            showCancelButton: false,
            focusConfirm: false,
        });
        await axios.post(`${process.env.REACT_APP_API_URL}/stripe/cancel_subscription.php`,
            {
                subId: selectedContractId,
                contractid: garageId,
                reason: data.rejectionReason
            })
            .then(response => {
                if (response.data.status === true) {
                    console.log(response.data);
                    Swal.fire({
                        title: 'Cancel Successfully',
                        text: response.data.message,
                        icon: 'success',
                    }).then(() => {
                        window.location.reload()
                    })

                } else {
                    Swal.fire({
                        title: 'Alert',
                        text: response.data.message,
                        icon: 'error',
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching data:', error);
            });
    }

    return (
        <section className="page-content sec-padding">
            <div className="container-fluid">
                <div className='row'>

                    <div className="sec-title row">
                        <div className="col-md-6 text-start">
                            <h3>All Payments</h3>
                        </div>
                        <div className="col-md-6 text-end">
                            <Link className='btn btn-primary btn-lg me-3' to='/view-contract'>All Contracts</Link>
                            {data && data[0] && data[0].allpayments && data[0].allpayments.status === 'canceled'
                                ?
                                <span className='text-danger'>Contract has been cancelled</span>
                                :
                                (userType === 'Owner' ? <button className='btn btn-danger btn-lg'
                                    onClick={() => OpenModal(data[0].subscription_id, 'pdfPreviewModalTwo')}
                                >Cancel Subscription</button>
                                    : ''
                                )
                            }
                        </div>
                    </div>


                    <div className="col-md-12 d-flex">
                        <input
                            className='form-control w-25 mx-2 py-2'
                            placeholder="Search Payments"
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                    </div>
                    <div className="table-responsive">
                        <table className='table table-hover'>
                            <thead>
                                <tr className='bg-primary'>
                                    <th>Stripe Details</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th>Amount</th>
                                    <th>Description</th>
                                    <th>Payment Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {displayedData.map((item) => (
                                    <tr key={item.id}>
                                        <td>
                                            <i>Customer Id : </i><b>{item.customer_id} </b><br />
                                            {/* <i>Payment Intent : </i><b>{item.payment_intent}</b> <br />
                                            <i>Payment Method Id </i>:<b> {item.payment_method_id}</b> <br /> */}
                                            <i>Subscription Id : </i><b>{item.subscription_id}</b> <br />
                                        </td>
                                        <td>{item.type !== 's' ? formatDate(item.startdate) : ''}</td>
                                        <td>{item.type !== 's' ? formatDate(item.enddate) : ''}</td>
                                        <td><i>Amount : </i><b>{item.amount}</b><br />
                                            <i>Application Fee : </i><b>{formatApplicationFee(item)}</b>
                                            {/* 
                                        s={item.contractStatus} */}
                                        </td>
                                        <td>{item.description}</td>
                                        <td>{item.created_at}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <div>
                        <button onClick={handlePreviousPage} disabled={currentPage === 1} className='btn btn-primary'>Previous</button>
                        <span> Page {currentPage} of {totalPages} </span>
                        <button onClick={handleNextPage} disabled={currentPage === totalPages} className='btn btn-primary'>Next</button>
                    </div>



                    <div className="modal fade" id="pdfPreviewModalTwo" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Cancelation Payment</h5>
                                    <button type="button" className="btn-close  close" data-dismiss="modal" aria-label="Close"
                                        onClick={() => closeModal('pdfPreviewModalTwo')}>
                                        <span aria-hidden="true"></span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <form onSubmit={handleSubmit2(handleAcceptModalSubmit)}>
                                        <div className="form-group row">
                                            <label className="form-label col-md-4" htmlFor="rejectionReason">Reason for Cancelation:</label>
                                            <div className="col-md-8 d-flex position-relative">
                                                <input
                                                    className="form-control" rows={3}
                                                    name='rejectionReason'
                                                    {...register2("rejectionReason", { required: true })}
                                                />
                                                {errors2.rejectionReason &&
                                                    <span className="text-danger la la-exclamation-circle error-icon">
                                                        <span className="badge badge-danger error-icon-text">Reason for Cancelation is Required</span>
                                                    </span>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group text-center">
                                            <button type="button" className="btn btn-secondary me-3" onClick={() => closeModal('pdfPreviewModalTwo')}>Cancel</button>
                                            <button type="submit" className="btn btn-primary">Submit</button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </section >
    );
};

export default ViewPayment;
